import { Turbo } from "@hotwired/turbo-rails"

// Un refresh della pagina (<turbo-stream action="refresh">: la risposta di un'altra azione o un broadcast) che arriva
// mentre un form sta inviando aspetta la fine dell'invio. Turbo rimanda gia' un refresh durante una visita, ma non
// durante l'invio di un form: la visita di refresh lo annullerebbe (navigator.stop), il server scriverebbe e la
// risposta con il toast non verrebbe mai applicata. Qui la visita del refresh (stesso indirizzo della pagina) viene
// fermata con turbo:before-visit finche' c'e' un invio in volo e ripartita a fine invio, con lo stesso debounce;
// se la risposta del form porta a un'altra visita (redirect), il refresh rimandato non parte (come in Turbo).
let inVolo = 0
let rimandato = false

document.addEventListener("turbo:submit-start", () => { inVolo += 1 })

document.addEventListener("turbo:submit-end", () => {
  inVolo = Math.max(0, inVolo - 1)
  if (inVolo === 0 && rimandato) {
    rimandato = false
    Turbo.session.refresh(document.baseURI)
  }
})

document.addEventListener("turbo:before-visit", (event) => {
  if (inVolo > 0 && event.detail.url === document.baseURI) {
    event.preventDefault()
    rimandato = true
  }
})
